<!--
  Allergen key + the dietary warning. Ground-coloured band so it reads as page
  furniture rather than a second white card, and the warning is a .ui-note
  callout instead of the brand-configured black bar.
-->
<section class="ui-ground allergens" *ngIf="allergens?.length || noteText">
  <div class="allergens__inner">
    <div class="ui-section allergens__head">
      <h2 class="ui-section__title">Food Allergies &amp; Intolerance</h2>
    </div>

    <ul class="allergens__list" *ngIf="allergens?.length">
      <li class="allergens__item" *ngFor="let allergen of allergens">
        <span class="allergens__icon" *ngIf="allergen.Link">
          <!-- the key sits at the foot of the page: fetch the icons only as it nears the screen -->
          <img
            [src]="allergen.Link"
            [alt]="allergen.Title"
            width="38"
            height="34"
            loading="lazy"
            decoding="async"
          />
        </span>
        <span class="allergens__label">{{ allergen.Title }}</span>
      </li>
    </ul>

  </div>

  <!-- the warning sits outside the 1180px column so it can use the whole band
       and shrink-wrap its text: one line where the screen allows, centred -->
  <div class="allergens__note-wrap" *ngIf="noteText">
    <p class="ui-note ui-note--callout allergens__note">
      <span>{{ noteText }}</span>
    </p>
  </div>
</section>
